import {useMutation} from "@tanstack/react-query";

import {updateMaterialFunctionMutationOptions} from "./update-material-function.mutation-options";

export function useUpdateMaterialFunction(materialFunctionId: string) {
  return useMutation(updateMaterialFunctionMutationOptions(materialFunctionId));
}
